import { SettingConst } from '../../types';

/**
 * Contains the key used to load a specific version of the cookie consent integration.When an empty string is used, we won't try to load anything
 */
export const COOKIE_CONSENT_KEY = 'COOKIE_CONSENT_KEY' as SettingConst<
  'COOKIE_CONSENT_KEY',
  string,
  'RETAILER' | 'RETAILER_HEAD_TAGS'
>;
